/* Homepage booklet feature: rotating "Did you know" teaser. Built 2026-09-15. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('[data-booklet-rotator]').forEach(function (rotator) {
      var items = Array.prototype.slice.call(rotator.querySelectorAll('[data-tease]'));
      if (items.length < 2) return;

      // No-JS fallback already shows every line. From here we hide all but the first.
      items.forEach(function (el, i) {
        if (i !== 0) el.hidden = true;
      });

      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) return; // static: first line only, no rotation

      var index = 0;
      var timer = null;

      function show(next) {
        items[index].hidden = true;
        index = next;
        items[index].hidden = false;
      }

      function start() {
        if (timer) return;
        timer = setInterval(function () {
          show((index + 1) % items.length);
        }, 4500);
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      start();
      rotator.addEventListener('mouseenter', stop);
      rotator.addEventListener('mouseleave', start);
      rotator.addEventListener('focusin', stop);
      rotator.addEventListener('focusout', start);
    });
  });
})();
